import Configuration from '@/agilis/util/Configuration'
import DataTableWithGroups from '@/agilis/components/DataTableWithGroups/DataTableWithGroups.vue'
import TrackerDataTableView from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.vue'

import L from 'lodash'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OrderTableItemView',

  components: {
    DataTableWithGroups,
    TrackerDataTableView
  },

  data () {
    return {
      deliveryAssociations: null,
      deliveryPayments: null,
      featureId: 'deliveryPayments',
      itemsKey: 'id'
    }
  },

  mounted () {
    this.fetchPayments()
  },

  watch: {
    deliveryAssociations: {
      handler (newValue, oldValue) {
        if (!L.isEqual(newValue, oldValue)) {
          this.fetchPayments()
          this.checkMissingDeliveryPayments()
        }
      }
    },
    paymentsAndAssociationsLoaded (ready) {
      if (ready) {
        this.$nextTick(() => this.checkMissingDeliveryPayments())
      }
    }
  },

  computed: {
    ...mapGetters({
      loading: 'loaderStore/loading',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerId: 'contextStore/trackerId',
      trackerTypeId: 'contextStore/trackerTypeId'
    }),

    paymentConfiguration () {
      return Configuration.getTrackerType(this.applicationId, this.trackerTypeId).trackerTypes.deliveryPayment.dataTable
    },

    jlAssertionContext () { // extend computed prop from the mixin
      const parentContext = TrackerDataTableView.computed.jlAssertionContext.apply(this)

      return {
        ...parentContext,
        deliveryPayments: this.deliveryPayments // adding delivery payments to the assertion context,
      }
    },

    deliveryIds () {
      let fromAssociations = []
      let fromPayments = []

      if (this.deliveryAssociations && this.deliveryAssociations.length) {
        fromAssociations = this.deliveryAssociations.map(association => association.target.id)
      }

      if (this.deliveryPayments && this.deliveryPayments.length) {
        fromPayments = this.deliveryPayments.map(
          payment => payment.deliveryId
        )
      }

      return Array.from(
        new Set([
          ...fromAssociations,
          ...fromPayments
        ])
      )
    },

    paymentsAndAssociationsLoaded () {
      return Array.isArray(this.deliveryPayments) && Array.isArray(this.deliveryAssociations)
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'notifyWarning': 'notificationStore/notifyWarning',
      'startLoader': 'loaderStore/startLoader',
      'stopLoader': 'loaderStore/stopLoader'
    }),

    async fetchPayments () {
      this.startLoader({ id: 'fetch-data' })

      try {
        const body = {
          filterTerms: [
            {
              field: 'order',
              operator: 'EQUALS',
              value: this.trackerId
            }
          ]
        }

        const url = this.$axios.agilisUrlQuery(
          this.applicationId,
          this.paymentConfiguration.querySelectMode
        )

        const response = await this.$axios.post(
          url,
          body,
          this.$axios.agilisRequestConfig(url)
        )

        const payments = response.data.items || []

        this.deliveryPayments = payments
      } catch (error) {
        this.notifyError(error)
      } finally {
        this.stopLoader({ id: 'fetch-data' })
      }
    },

    checkMissingDeliveryPayments () {
      if (this.deliveryPayments === null) return
      if (this.deliveryAssociations === null) return
      const deliveryIds = this.deliveryAssociations.map(association => association.target.id)
      const missingDeliveryPayment = this.deliveryPayments.find(payment => !deliveryIds.includes(payment.deliveryId))
      if (missingDeliveryPayment) {
        this.notifyWarning({ 'message': this.$t('sales.error.missingOrderDeliveryAssociation', { 'trackerId': missingDeliveryPayment.deliveryId }) })
      }
    },

    filterPayments (deliveryId) {
      if (this.deliveryPayments === null) return []
      return this.deliveryPayments.filter(payments => payments.deliveryId === deliveryId)
    },

    deliveryTitle (deliveryId) {
      return this.$t('label.deliveryIdPayments', { deliveryId: deliveryId })
    },

    handleAssociationsLoaded (associations) {
      this.deliveryAssociations = associations.filter(association => association.target.trackerTypeId === 'delivery')
    }
  }
}
